export function getWebpPngFallbackSrc(src?: string | null): string | null {
  return src?.endsWith('.webp') ? `${src.slice(0, -5)}.png` : null;
}
